import { observer } from "mobx-react-lite";
import { stores } from "../../stores";
import { GLOBAL_MEMORY } from "../../stores/memoryStore";
import { ParameterType } from "../../model";
import { getGlobalParameterStateStyle, getPresetParameterStateStyle } from "../../utils/styling";
import { InputRadioLabel } from "./InputRadioLabel";

interface ParameterProps {
    parameter: ParameterType;
    presetNumber?: number;
}

type RadioValue = { [key: string]: string };

export const InputRadio = observer(({ parameter, presetNumber = GLOBAL_MEMORY }: ParameterProps) => {
    function handleChange(value: number) {
        stores.memory.setValue(parameter, value, presetNumber);
        stores.midi.save(presetNumber);
    }

    function isChecked(value: number) {
        return value === getCurrentValue();
    }

    function getCurrentValue() {
        const currentValue = stores.memory.getValue(parameter, presetNumber);
        const validValues = parameter.values.map((kv: RadioValue) => parseInt(Object.keys(kv)[0], 10));
        return validValues.includes(currentValue) ? currentValue : 0;
    }

    const style = parameter.type === "global"
        ? getGlobalParameterStateStyle(parameter.id)
        : getPresetParameterStateStyle(parameter.id, presetNumber);

    return (
        <div className={`param-input input-radio state ${style}`}>
            {parameter.values.map((kv: RadioValue, i: number) => {
                const entry = Object.entries(kv);
                const value: number = parseInt(entry[0][0], 10);
                if (isNaN(value)) {
                    console.error("invalid configuration value for radio", parameter, entry);
                    return null;
                } else {
                    const label: string = entry[0][1];
                    return (
                        <label key={i}>
                            <input
                                type="radio"
                                name={`config.${parameter.offset}`}
                                value={value}
                                checked={isChecked(value)}
                                onChange={() => handleChange(value)}
                            />
                            <InputRadioLabel label={label} />
                        </label>
                    );
                }
            })}
        </div>
    );
});